import { Shark, View } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import $ from "jquery";

import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { documentListView } from "./documentListView";
import { documentManager } from "../../_shark_jaws/managers/documentManager";

import templateContent from "./gallery-edit.html";
import { galleryManager } from "../../_shark_jaws/managers/galleryManager";
import { pictureManager } from "../../_shark_jaws/managers/pictureManager";
import { breadcrumbComponent } from "../../_shark_jaws/components/breadcrumbComponent";
import { pictureToolsComponent } from "../../_shark_jaws/components/pictureToolsComponent";

import "../../css/ekko-lightbox.css";
import "../../js/libs-public/ekko-lightbox.js";

class GalleryEditView extends View {
	constructor () {
		super("galleryEditView");
		this.setTemplate(templateContent);
	}


	
	afterRender () {
		$(document).off('click', '[data-toggle="lightbox"]', this.initLightBox);
		$(document).on('click', '[data-toggle="lightbox"]', this.initLightBox);

		// $(document).on('click', '[data-toggle="lightbox"]', function(event) {
		// 	event.preventDefault();
		// 	$(this).ekkoLightbox();
		// });
	}

	initLightBox (event) {
		event.preventDefault();
		$(event.currentTarget).ekkoLightbox({
			alwaysShowClose: true
		});
	}

	backToDocumentListBtn_clickHandler () {
		Shark.openPage(documentListView);
	}

	beforeLoad () {
		breadcrumbComponent.set("isActive", false);
		Shark.set("pictureList", []);
		pictureManager.getList(Shark.get("currGallery"));
	}

	beforeRender () {
		this.set({
			currGallery: Shark.get("currGallery"),
			pictureList: Shark.get("pictureList"),
			productLineList: Shark.get("productLineList"),
			// __cdnURL: process.env.CDN_URL,
			__isEditing: Shark.get("isEditing"),
			__coverName: Shark.__generateGUID(),
			__nextPictureSaveName: Shark.__generateGUID()
		});
	}

	cancelEditsBtn_clickHandler () {
		const currGallery = Shark.get("currGallery");
		
		if (!currGallery.__isDirty || (currGallery.__isDirty && confirm("Sei sicuro di voler annullare le modifiche apportate?"))) {
			currGallery.restore();
			Shark.set("isEditing", false);

			if (currGallery.guid !== "") {
				this.set({
					__isEditing: Shark.get("isEditing")
				});
				Shark.render();
			}
			else {
				Shark.openPage(documentListView);
			}
		}
	}

	deleteGalleryBtn_clickHandler () {
		if (confirm("Sei sicuro di voler eliminare questa galleria?")) {
			galleryManager.delete(Shark.get("currGallery"));
		}
	}

	deleteFileBtn_clickHandler () {
		const newDocument = Shark.get("currGallery");

		newDocument.set("fileSize", 0);
		newDocument.set("fileType", "");
		newDocument.set("fileURL", "");

		Shark.render();
	}

	editGalleryBtn_clickHandler () {
		Shark.set("isEditing", !Shark.get("isEditing"));
		this.set({
			__isEditing: Shark.get("isEditing")
		});
		Shark.render();
	}

	galleryManager_savedHandler () {
		Shark.set("isEditing", !Shark.get("isEditing"));
		this.set({
			__isEditing: Shark.get("isEditing")
		});
		Shark.render();
	}

	galleryManager_saveErrorHandler () {
		console.log("documentSaveErrorHandler");
	}

	galleryManager_deletedHandler () {
		Shark.openPage(documentListView);
	}

	init () {
		this.addComponents([breadcrumbComponent, mainNavComponent, pictureToolsComponent]);
	}

	fileOverrideConfirmation (path, name, type) {
		if (confirm("Il file che stai cercando di caricare esiste già. Vuoi comunque caricarlo?")) {
			documentManager.uploadDuplicate(path, name, type);
		}
		else {
			const newDocument = Shark.get("currGallery");

			newDocument.set("fileSize", 0);
			newDocument.set("fileType", "");
			newDocument.set("fileURL", "");
			newDocument.set("name", "");

			Shark.render();
		}
	}

	pictureManager_listChangedHandler () {
		this.set({
			pictureList: Shark.get("pictureList")
		});
		Shark.render();
	}

	profileImageDeleteBtn_clickHandler () {
		Shark.get("currGallery").set("coverURL", "");
		Shark.render();
	}

	saveGalleryBtn_clickHandler () {
		galleryManager.save(Shark.get("currGallery"));
	}

	uploadedCover_changeHandler (event) {
		NousCore.api.uploadFiles(event.target, "gallery/upload")
		.then(function(jsonData) {
			const savedFile = jsonData.payload.items[0];

			switch (savedFile.rc) {
				case 1:
					const currGallery = Shark.get("currGallery");
					currGallery.set("coverURL", "/" + savedFile.filePath);
					break;
				case 95:
					galleryEditView.fileOverrideConfirmation(savedFile.errors[0].erroData.tempFile, savedFile.errors[0].erroData.originalName, "coverURL");
					break;
				default:
					alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			}

			Shark.render();
		});
	}

	uploadedImage_changeHandler (event) {

		NousCore.api.uploadFiles(event.target, "picture/upload")
		.then(function(jsonData) {

			jsonData.payload.items.forEach(item => {
				const newPicture = Shark.getInstance("Picture", {
					// createdAt: "0000-00-00 00:00:00"
					createdByGuid: Shark.get("currUser").guid,
					fileSize: item.size,
					fileType: item.type,
					fileURL: "/" + item.filePath,
					galleryGuid: Shark.get("currGallery").guid,
					name: item.name,
					status: 1,
					tags: [],
					type: "gallery",
				});

				pictureManager.save(newPicture);
			});

			// switch (savedFile.rc) {
			// 	case 1:

			// 		// const newDocument = Shark.get("editingDocument");
			// 		// newDocument.set("thumbnailURL", savedFile.filePath);
			// 		break;
			// 	case 95:
			// 		documentEditView.fileOverrideConfirmation(savedFile.errors[0].erroData.tempFile, savedFile.errors[0].erroData.originalName, "thumbnailURL");
			// 		break;
			// 	default:
			// 		alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
			// }

			Shark.render();
		});

		// pictureManager.upload(event.target);
	}

	addPicturesBtn_clickHandler () {
		document.querySelector("#uploadedImage").click();
	}
}

const galleryEditView = new GalleryEditView();

Shark.registerView(galleryEditView);

export { galleryEditView };
